.pf-v5-c-button {
  --pf-v5-c-button--PaddingTop: var(--pf-v5-global--spacer--form-element);
  --pf-v5-c-button--PaddingRight: var(--pf-v5-global--spacer--md);
  --pf-v5-c-button--PaddingBottom: var(--pf-v5-global--spacer--form-element);
  --pf-v5-c-button--PaddingLeft: var(--pf-v5-global--spacer--md);
  --pf-v5-c-button--LineHeight: var(--pf-v5-global--LineHeight--md);
  --pf-v5-c-button--FontWeight: var(--pf-v5-global--FontWeight--normal);
  --pf-v5-c-button--FontSize: var(--pf-v5-global--FontSize--md);
  --pf-v5-c-button--BackgroundColor: transparent;
  --pf-v5-c-button--BorderRadius: var(--pf-v5-global--BorderRadius--sm);
  --pf-v5-c-button--after--BorderRadius: var(--pf-v5-global--BorderRadius--sm);
  --pf-v5-c-button--after--BorderColor: transparent;
  --pf-v5-c-button--after--BorderWidth: var(--pf-v5-global--BorderWidth--sm);
  --pf-v5-c-button--hover--after--BorderWidth: var(--pf-v5-global--BorderWidth--md);
  --pf-v5-c-button--focus--after--BorderWidth: var(--pf-v5-global--BorderWidth--md);
  --pf-v5-c-button--active--after--BorderWidth: var(--pf-v5-global--BorderWidth--md);
  --pf-v5-c-button--disabled--Color: var(--pf-v5-global--disabled-color--100);
  --pf-v5-c-button--disabled--BackgroundColor: var(--pf-v5-global--disabled-color--200);
  --pf-v5-c-button--disabled--after--BorderColor: transparent;
  --pf-v5-c-button--m-primary--BackgroundColor: var(--pf-v5-global--primary-color--100);
  --pf-v5-c-button--m-primary--Color: var(--pf-v5-global--Color--light-100);
  --pf-v5-c-button--m-primary--hover--BackgroundColor: var(--pf-v5-global--primary-color--200);
  --pf-v5-c-button--m-primary--hover--Color: var(--pf-v5-global--Color--light-100);
  --pf-v5-c-button--m-primary--focus--BackgroundColor: var(--pf-v5-global--primary-color--200);
  --pf-v5-c-button--m-primary--focus--Color: var(--pf-v5-global--Color--light-100);
  --pf-v5-c-button--m-primary--active--BackgroundColor: var(--pf-v5-global--primary-color--200);
  --pf-v5-c-button--m-primary--active--Color: var(--pf-v5-global--Color--light-100);
  --pf-v5-c-button--m-secondary--BackgroundColor: transparent;
  --pf-v5-c-button--m-secondary--after--BorderColor: var(--pf-v5-global--primary-color--100);
  --pf-v5-c-button--m-secondary--Color: var(--pf-v5-global--primary-color--100);
  --pf-v5-c-button--m-secondary--hover--BackgroundColor: transparent;
  --pf-v5-c-button--m-secondary--hover--after--BorderColor: var(--pf-v5-global--primary-color--100);
  --pf-v5-c-button--m-secondary--hover--Color: var(--pf-v5-global--primary-color--100);
  --pf-v5-c-button--m-secondary--focus--BackgroundColor: transparent;
  --pf-v5-c-button--m-secondary--focus--after--BorderColor: var(--pf-v5-global--primary-color--100);
  --pf-v5-c-button--m-secondary--focus--Color: var(--pf-v5-global--primary-color--100);
  --pf-v5-c-button--m-secondary--active--BackgroundColor: transparent;
  --pf-v5-c-button--m-secondary--active--after--BorderColor: var(--pf-v5-global--primary-color--100);
  --pf-v5-c-button--m-secondary--active--Color: var(--pf-v5-global--primary-color--100);
  --pf-v5-c-button--m-secondary--m-danger--BackgroundColor: transparent;
  --pf-v5-c-button--m-secondary--m-danger--Color: var(--pf-v5-global--danger-color--100);
  --pf-v5-c-button--m-secondary--m-danger--after--BorderColor: var(--pf-v5-global--danger-color--100);
  --pf-v5-c-button--m-secondary--m-danger--hover--BackgroundColor: transparent;
  --pf-v5-c-button--m-secondary--m-danger--hover--Color: var(--pf-v5-global--danger-color--200);
  --pf-v5-c-button--m-secondary--m-danger--hover--after--BorderColor: var(--pf-v5-global--danger-color--100);
  --pf-v5-c-button--m-secondary--m-danger--focus--BackgroundColor: transparent;
  --pf-v5-c-button--m-secondary--m-danger--focus--Color: var(--pf-v5-global--danger-color--200);
  --pf-v5-c-button--m-secondary--m-danger--focus--after--BorderColor: var(--pf-v5-global--danger-color--100);
  --pf-v5-c-button--m-secondary--m-danger--active--BackgroundColor: transparent;
  --pf-v5-c-button--m-secondary--m-danger--active--Color: var(--pf-v5-global--danger-color--200);
  --pf-v5-c-button--m-secondary--m-danger--active--after--BorderColor: var(--pf-v5-global--danger-color--100);
  --pf-v5-c-button--m-tertiary--BackgroundColor: transparent;
  --pf-v5-c-button--m-tertiary--after--BorderColor: var(--pf-v5-global--Color--100);
  --pf-v5-c-button--m-tertiary--Color: var(--pf-v5-global--Color--100);
  --pf-v5-c-button--m-tertiary--hover--BackgroundColor: transparent;
  --pf-v5-c-button--m-tertiary--hover--after--BorderColor: var(--pf-v5-global--Color--100);
  --pf-v5-c-button--m-tertiary--hover--Color: var(--pf-v5-global--Color--100);
  --pf-v5-c-button--m-tertiary--focus--BackgroundColor: transparent;
  --pf-v5-c-button--m-tertiary--focus--after--BorderColor: var(--pf-v5-global--Color--100);
  --pf-v5-c-button--m-tertiary--focus--Color: var(--pf-v5-global--Color--100);
  --pf-v5-c-button--m-tertiary--active--BackgroundColor: transparent;
  --pf-v5-c-button--m-tertiary--active--after--BorderColor: var(--pf-v5-global--Color--100);
  --pf-v5-c-button--m-tertiary--active--Color: var(--pf-v5-global--Color--100);
  --pf-v5-c-button--m-warning--BackgroundColor: var(--pf-v5-global--warning-color--100);
  --pf-v5-c-button--m-warning--Color: var(--pf-v5-global--Color--dark-100);
  --pf-v5-c-button--m-warning--hover--BackgroundColor: var(--pf-v5-global--palette--gold-500);
  --pf-v5-c-button--m-warning--hover--Color: var(--pf-v5-global--Color--dark-100);
  --pf-v5-c-button--m-warning--focus--BackgroundColor: var(--pf-v5-global--palette--gold-500);
  --pf-v5-c-button--m-warning--focus--Color: var(--pf-v5-global--Color--dark-100);
  --pf-v5-c-button--m-warning--active--BackgroundColor: var(--pf-v5-global--palette--gold-500);
  --pf-v5-c-button--m-warning--active--Color: var(--pf-v5-global--Color--dark-100);
  --pf-v5-c-button--m-danger--BackgroundColor: var(--pf-v5-global--danger-color--100);
  --pf-v5-c-button--m-danger--Color: var(--pf-v5-global--Color--light-100);
  --pf-v5-c-button--m-danger--hover--BackgroundColor: var(--pf-v5-global--danger-color--200);
  --pf-v5-c-button--m-danger--hover--Color: var(--pf-v5-global--Color--light-100);
  --pf-v5-c-button--m-danger--focus--BackgroundColor: var(--pf-v5-global--danger-color--200);
  --pf-v5-c-button--m-danger--focus--Color: var(--pf-v5-global--Color--light-100);
  --pf-v5-c-button--m-danger--active--BackgroundColor: var(--pf-v5-global--danger-color--200);
  --pf-v5-c-button--m-danger--active--Color: var(--pf-v5-global--Color--light-100);
  --pf-v5-c-button--m-link--BackgroundColor: transparent;
  --pf-v5-c-button--m-link--Color: var(--pf-v5-global--link--Color);
  --pf-v5-c-button--m-link--hover--BackgroundColor: transparent;
  --pf-v5-c-button--m-link--hover--Color: var(--pf-v5-global--link--Color--hover);
  --pf-v5-c-button--m-link--focus--BackgroundColor: transparent;
  --pf-v5-c-button--m-link--focus--Color: var(--pf-v5-global--link--Color--hover);
  --pf-v5-c-button--m-link--active--BackgroundColor: transparent;
  --pf-v5-c-button--m-link--active--Color: var(--pf-v5-global--link--Color--hover);
  --pf-v5-c-button--m-link--disabled--BackgroundColor: transparent;
  --pf-v5-c-button--m-link--disabled--Color: var(--pf-v5-global--disabled-color--100);
  --pf-v5-c-button--m-link--m-inline--FontSize: inherit;
  --pf-v5-c-button--m-link--m-inline--hover--TextDecoration: var(--pf-v5-global--link--TextDecoration--hover);
  --pf-v5-c-button--m-link--m-inline--hover--Color: var(--pf-v5-global--link--Color--hover);
  --pf-v5-c-button--m-link--m-inline--PaddingTop: 0;
  --pf-v5-c-button--m-link--m-inline--PaddingRight: 0;
  --pf-v5-c-button--m-link--m-inline--PaddingBottom: 0;
  --pf-v5-c-button--m-link--m-inline--PaddingLeft: 0;
  --pf-v5-c-button--m-link--m-inline__progress--Left: var(--pf-v5-global--spacer--xs);
  --pf-v5-c-button--m-link--m-inline--m-in-progress--PaddingLeft: calc(var(--pf-v5-c-button--m-link--m-inline__progress--Left) + 1rem + var(--pf-v5-global--spacer--sm));
  --pf-v5-c-button--m-link--m-danger--BackgroundColor: transparent;
  --pf-v5-c-button--m-link--m-danger--Color: var(--pf-v5-global--danger-color--100);
  --pf-v5-c-button--m-link--m-danger--hover--BackgroundColor: transparent;
  --pf-v5-c-button--m-link--m-danger--hover--Color: var(--pf-v5-global--danger-color--200);
  --pf-v5-c-button--m-link--m-danger--focus--BackgroundColor: transparent;
  --pf-v5-c-button--m-link--m-danger--focus--Color: var(--pf-v5-global--danger-color--200);
  --pf-v5-c-button--m-link--m-danger--active--BackgroundColor: transparent;
  --pf-v5-c-button--m-link--m-danger--active--Color: var(--pf-v5-global--danger-color--200);
  --pf-v5-c-button--m-plain--BackgroundColor: transparent;
  --pf-v5-c-button--m-plain--Color: var(--pf-v5-global--Color--200);
  --pf-v5-c-button--m-plain--hover--BackgroundColor: transparent;
  --pf-v5-c-button--m-plain--hover--Color: var(--pf-v5-global--Color--100);
  --pf-v5-c-button--m-plain--focus--BackgroundColor: transparent;
  --pf-v5-c-button--m-plain--focus--Color: var(--pf-v5-global--Color--100);
  --pf-v5-c-button--m-plain--active--BackgroundColor: transparent;
  --pf-v5-c-button--m-plain--active--Color: var(--pf-v5-global--Color--100);
  --pf-v5-c-button--m-plain--disabled--Color: var(--pf-v5-global--disabled-color--200);
  --pf-v5-c-button--m-plain--disabled--BackgroundColor: transparent;
  --pf-v5-c-button--m-control--BackgroundColor: var(--pf-v5-global--BackgroundColor--100);
  --pf-v5-c-button--m-control--Color: var(--pf-v5-global--Color--100);
  --pf-v5-c-button--m-control--BorderRadius: 0;
  --pf-v5-c-button--m-control--after--BorderWidth: var(--pf-v5-global--BorderWidth--sm);
  --pf-v5-c-button--m-control--after--BorderTopColor: var(--pf-v5-global--BorderColor--300);
  --pf-v5-c-button--m-control--after--BorderRightColor: var(--pf-v5-global--BorderColor--300);
  --pf-v5-c-button--m-control--after--BorderBottomColor: var(--pf-v5-global--BorderColor--200);
  --pf-v5-c-button--m-control--after--BorderLeftColor: var(--pf-v5-global--BorderColor--300);
  --pf-v5-c-button--m-control--disabled--BackgroundColor: var(--pf-v5-global--disabled-color--300);
  --pf-v5-c-button--m-control--hover--BackgroundColor: var(--pf-v5-global--BackgroundColor--100);
  --pf-v5-c-button--m-control--hover--Color: var(--pf-v5-global--Color--100);
  --pf-v5-c-button--m-control--hover--after--BorderBottomWidth: var(--pf-v5-global--BorderWidth--md);
  --pf-v5-c-button--m-control--hover--after--BorderBottomColor: var(--pf-v5-global--active-color--100);
  --pf-v5-c-button--m-control--active--BackgroundColor: var(--pf-v5-global--BackgroundColor--100);
  --pf-v5-c-button--m-control--active--Color: var(--pf-v5-global--Color--100);
  --pf-v5-c-button--m-control--active--after--BorderBottomWidth: var(--pf-v5-global--BorderWidth--md);
  --pf-v5-c-button--m-control--active--after--BorderBottomColor: var(--pf-v5-global--active-color--100);
  --pf-v5-c-button--m-control--focus--BackgroundColor: var(--pf-v5-global--BackgroundColor--100);
  --pf-v5-c-button--m-control--focus--Color: var(--pf-v5-global--Color--100);
  --pf-v5-c-button--m-control--focus--after--BorderBottomWidth: var(--pf-v5-global--BorderWidth--md);
  --pf-v5-c-button--m-control--focus--after--BorderBottomColor: var(--pf-v5-global--active-color--100);
  --pf-v5-c-button--m-control--m-expanded--BackgroundColor: var(--pf-v5-global--BackgroundColor--100);
  --pf-v5-c-button--m-control--m-expanded--Color: var(--pf-v5-global--Color--100);
  --pf-v5-c-button--m-control--m-expanded--after--BorderBottomWidth: var(--pf-v5-global--BorderWidth--md);
  --pf-v5-c-button--m-control--m-expanded--after--BorderBottomColor: var(--pf-v5-global--active-color--100);
  --pf-v5-c-button--m-small--FontSize: var(--pf-v5-global--FontSize--sm);
  --pf-v5-c-button--m-display-lg--PaddingTop: var(--pf-v5-global--spacer--md);
  --pf-v5-c-button--m-display-lg--PaddingRight: var(--pf-v5-global--spacer--xl);
  --pf-v5-c-button--m-display-lg--PaddingBottom: var(--pf-v5-global--spacer--md);
  --pf-v5-c-button--m-display-lg--PaddingLeft: var(--pf-v5-global--spacer--xl);
  --pf-v5-c-button--m-display-lg--FontWeight: var(--pf-v5-global--FontWeight--bold);
  --pf-v5-c-button--m-link--m-display-lg--FontSize: var(--pf-v5-global--FontSize--lg);
  --pf-v5-c-button__icon--m-start--MarginRight: var(--pf-v5-global--spacer--xs);
  --pf-v5-c-button__icon--m-end--MarginLeft: var(--pf-v5-global--spacer--xs);
  --pf-v5-c-button__progress--width: calc(var(--pf-v5-global--icon--FontSize--md) + var(--pf-v5-global--spacer--sm));
  --pf-v5-c-button__progress--Opacity: 0;
  --pf-v5-c-button__progress--TranslateY: -50%;
  --pf-v5-c-button__progress--TranslateX: 0;
  --pf-v5-c-button__progress--Top: 50%;
  --pf-v5-c-button__progress--Left: var(--pf-v5-global--spacer--md);
  --pf-v5-c-button--m-progress--TransitionProperty: padding;
  --pf-v5-c-button--m-progress--TransitionDuration: var(--pf-v5-global--TransitionDuration);
  --pf-v5-c-button--m-progress--PaddingRight: calc(var(--pf-v5-global--spacer--md) + var(--pf-v5-c-button__progress--width) / 2);
  --pf-v5-c-button--m-progress--PaddingLeft: calc(var(--pf-v5-global--spacer--md) + var(--pf-v5-c-button__progress--width) / 2);
  --pf-v5-c-button--m-in-progress--PaddingRight: var(--pf-v5-global--spacer--md);
  --pf-v5-c-button--m-in-progress--PaddingLeft: calc(var(--pf-v5-global--spacer--md) + var(--pf-v5-c-button__progress--width));
  --pf-v5-c-button--m-in-progress--m-plain--Color: var(--pf-v5-global--primary-color--100);
  --pf-v5-c-button--m-in-progress--m-plain__progress--Left: 50%;
  --pf-v5-c-button--m-in-progress--m-plain__progress--TranslateX: -50%;
  --pf-v5-c-button__count--MarginLeft: var(--pf-v5-global--spacer--sm);
  --pf-v5-c-button--disabled__c-badge--Color: var(--pf-v5-global--Color--dark-100);
  --pf-v5-c-button--disabled__c-badge--BackgroundColor: var(--pf-v5-global--BackgroundColor--200);
  --pf-v5-c-button--m-primary__c-badge--BorderColor: var(--pf-v5-global--BorderColor--300);
  --pf-v5-c-button--m-primary__c-badge--BorderWidth: var(--pf-v5-global--BorderWidth--sm);
  position: relative;
  display: inline-block;
  padding: var(--pf-v5-c-button--PaddingTop) var(--pf-v5-c-button--PaddingRight) var(--pf-v5-c-button--PaddingBottom) var(--pf-v5-c-button--PaddingLeft);
  font-size: var(--pf-v5-c-button--FontSize);
  font-weight: var(--pf-v5-c-button--FontWeight);
  line-height: var(--pf-v5-c-button--LineHeight);
  text-align: center;
  white-space: nowrap;
  user-select: none;
  border: 0;
  border-radius: var(--pf-v5-c-button--BorderRadius);
}
.pf-v5-c-button::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  content: "";
  border: var(--pf-v5-c-button--after--BorderWidth) solid;
  border-color: var(--pf-v5-c-button--after--BorderColor);
  border-radius: var(--pf-v5-c-button--after--BorderRadius);
}
.pf-v5-c-button:hover {
  --pf-v5-c-button--after--BorderWidth: var(--pf-v5-c-button--hover--after--BorderWidth);
  text-decoration: none;
}
.pf-v5-c-button:focus {
  --pf-v5-c-button--after--BorderWidth: var(--pf-v5-c-button--focus--after--BorderWidth);
}
.pf-v5-c-button:active, .pf-v5-c-button.pf-m-active {
  --pf-v5-c-button--after--BorderWidth: var(--pf-v5-c-button--active--after--BorderWidth);
}
.pf-v5-c-button.pf-m-block {
  display: block;
  width: 100%;
}
.pf-v5-c-button.pf-m-small {
  --pf-v5-c-button--FontSize: var(--pf-v5-c-button--m-small--FontSize);
}
.pf-v5-c-button.pf-m-primary.pf-m-display-lg, .pf-v5-c-button.pf-m-secondary.pf-m-display-lg, .pf-v5-c-button.pf-m-tertiary.pf-m-display-lg, .pf-v5-c-button.pf-m-link.pf-m-display-lg {
  --pf-v5-c-button--PaddingTop: var(--pf-v5-c-button--m-display-lg--PaddingTop);
  --pf-v5-c-button--PaddingRight: var(--pf-v5-c-button--m-display-lg--PaddingRight);
  --pf-v5-c-button--PaddingBottom: var(--pf-v5-c-button--m-display-lg--PaddingBottom);
  --pf-v5-c-button--PaddingLeft: var(--pf-v5-c-button--m-display-lg--PaddingLeft);
  --pf-v5-c-button--FontWeight: var(--pf-v5-c-button--m-display-lg--FontWeight);
}
.pf-v5-c-button.pf-m-primary {
  color: var(--pf-v5-c-button--m-primary--Color);
  background-color: var(--pf-v5-c-button--m-primary--BackgroundColor);
}
.pf-v5-c-button.pf-m-primary:hover {
  --pf-v5-c-button--m-primary--Color: var(--pf-v5-c-button--m-primary--hover--Color);
  --pf-v5-c-button--m-primary--BackgroundColor: var(--pf-v5-c-button--m-primary--hover--BackgroundColor);
}
.pf-v5-c-button.pf-m-primary:focus {
  --pf-v5-c-button--m-primary--Color: var(--pf-v5-c-button--m-primary--focus--Color);
  --pf-v5-c-button--m-primary--BackgroundColor: var(--pf-v5-c-button--m-primary--focus--BackgroundColor);
}
.pf-v5-c-button.pf-m-primary:active, .pf-v5-c-button.pf-m-primary.pf-m-active {
  --pf-v5-c-button--m-primary--Color: var(--pf-v5-c-button--m-primary--active--Color);
  --pf-v5-c-button--m-primary--BackgroundColor: var(--pf-v5-c-button--m-primary--active--BackgroundColor);
}
.pf-v5-c-button.pf-m-primary .pf-v5-c-badge.pf-m-unread {
  border: var(--pf-v5-c-button--m-primary__c-badge--BorderWidth) solid var(--pf-v5-c-button--m-primary__c-badge--BorderColor);
}
.pf-v5-c-button.pf-m-secondary {
  --pf-v5-c-button--after--BorderColor: var(--pf-v5-c-button--m-secondary--after--BorderColor);
  color: var(--pf-v5-c-button--m-secondary--Color);
  background-color: var(--pf-v5-c-button--m-secondary--BackgroundColor);
}
.pf-v5-c-button.pf-m-secondary:hover {
  --pf-v5-c-button--m-secondary--Color: var(--pf-v5-c-button--m-secondary--hover--Color);
  --pf-v5-c-button--m-secondary--BackgroundColor: var(--pf-v5-c-button--m-secondary--hover--BackgroundColor);
  --pf-v5-c-button--after--BorderColor: var(--pf-v5-c-button--m-secondary--hover--after--BorderColor);
}
.pf-v5-c-button.pf-m-secondary:focus {
  --pf-v5-c-button--m-secondary--Color: var(--pf-v5-c-button--m-secondary--focus--Color);
  --pf-v5-c-button--m-secondary--BackgroundColor: var(--pf-v5-c-button--m-secondary--focus--BackgroundColor);
  --pf-v5-c-button--after--BorderColor: var(--pf-v5-c-button--m-secondary--focus--after--BorderColor);
}
.pf-v5-c-button.pf-m-secondary.pf-m-active, .pf-v5-c-button.pf-m-secondary:active {
  --pf-v5-c-button--m-secondary--Color: var(--pf-v5-c-button--m-secondary--active--Color);
  --pf-v5-c-button--m-secondary--BackgroundColor: var(--pf-v5-c-button--m-secondary--active--BackgroundColor);
  --pf-v5-c-button--after--BorderColor: var(--pf-v5-c-button--m-secondary--active--after--BorderColor);
}
.pf-v5-c-button.pf-m-tertiary {
  --pf-v5-c-button--after--BorderColor: var(--pf-v5-c-button--m-tertiary--after--BorderColor);
  color: var(--pf-v5-c-button--m-tertiary--Color);
  background-color: var(--pf-v5-c-button--m-tertiary--BackgroundColor);
}
.pf-v5-c-button.pf-m-tertiary:hover {
  --pf-v5-c-button--m-tertiary--Color: var(--pf-v5-c-button--m-tertiary--hover--Color);
  --pf-v5-c-button--m-tertiary--BackgroundColor: var(--pf-v5-c-button--m-tertiary--hover--BackgroundColor);
  --pf-v5-c-button--after--BorderColor: var(--pf-v5-c-button--m-tertiary--hover--after--BorderColor);
}
.pf-v5-c-button.pf-m-tertiary:focus {
  --pf-v5-c-button--m-tertiary--Color: var(--pf-v5-c-button--m-tertiary--focus--Color);
  --pf-v5-c-button--m-tertiary--BackgroundColor: var(--pf-v5-c-button--m-tertiary--focus--BackgroundColor);
  --pf-v5-c-button--after--BorderColor: var(--pf-v5-c-button--m-tertiary--focus--after--BorderColor);
}
.pf-v5-c-button.pf-m-tertiary:active, .pf-v5-c-button.pf-m-tertiary.pf-m-active {
  --pf-v5-c-button--m-tertiary--Color: var(--pf-v5-c-button--m-tertiary--active--Color);
  --pf-v5-c-button--m-tertiary--BackgroundColor: var(--pf-v5-c-button--m-tertiary--active--BackgroundColor);
  --pf-v5-c-button--after--BorderColor: var(--pf-v5-c-button--m-tertiary--active--after--BorderColor);
}
.pf-v5-c-button.pf-m-link {
  --pf-v5-c-button--disabled--BackgroundColor: var(--pf-v5-c-button--m-link--disabled--BackgroundColor);
  --pf-v5-c-button--disabled--Color: var(--pf-v5-c-button--m-link--disabled--Color);
  color: var(--pf-v5-c-button--m-link--Color);
  background-color: var(--pf-v5-c-button--m-link--BackgroundColor);
}
.pf-v5-c-button.pf-m-link:not(.pf-m-inline):hover {
  --pf-v5-c-button--m-link--Color: var(--pf-v5-c-button--m-link--hover--Color);
  --pf-v5-c-button--m-link--BackgroundColor: var(--pf-v5-c-button--m-link--hover--BackgroundColor);
}
.pf-v5-c-button.pf-m-link:not(.pf-m-inline):focus {
  --pf-v5-c-button--m-link--Color: var(--pf-v5-c-button--m-link--focus--Color);
  --pf-v5-c-button--m-link--BackgroundColor: var(--pf-v5-c-button--m-link--focus--BackgroundColor);
}
.pf-v5-c-button.pf-m-link:not(.pf-m-inline):active, .pf-v5-c-button.pf-m-link:not(.pf-m-inline).pf-m-active {
  --pf-v5-c-button--m-link--Color: var(--pf-v5-c-button--m-link--active--Color);
  --pf-v5-c-button--m-link--BackgroundColor: var(--pf-v5-c-button--m-link--active--BackgroundColor);
}
.pf-v5-c-button.pf-m-link.pf-m-inline {
  --pf-v5-c-button--FontSize: var(--pf-v5-c-button--m-link--m-inline--FontSize);
  --pf-v5-c-button__progress--Left: var(--pf-v5-c-button--m-link--m-inline__progress--Left);
  display: inline;
  padding: var(--pf-v5-c-button--m-link--m-inline--PaddingTop) var(--pf-v5-c-button--m-link--m-inline--PaddingRight) var(--pf-v5-c-button--m-link--m-inline--PaddingBottom) var(--pf-v5-c-button--m-link--m-inline--PaddingLeft);
  text-align: left;
  white-space: normal;
  cursor: pointer;
}
.pf-v5-c-button.pf-m-link.pf-m-inline:hover {
  --pf-v5-c-button--m-link--Color: var(--pf-v5-c-button--m-link--m-inline--hover--Color);
  text-decoration: var(--pf-v5-c-button--m-link--m-inline--hover--TextDecoration);
}
.pf-v5-c-button.pf-m-link.pf-m-display-lg {
  --pf-v5-c-button--FontSize: var(--pf-v5-c-button--m-link--m-display-lg--FontSize);
}
.pf-v5-c-button.pf-m-danger {
  color: var(--pf-v5-c-button--m-danger--Color);
  background-color: var(--pf-v5-c-button--m-danger--BackgroundColor);
}
.pf-v5-c-button.pf-m-danger:hover {
  --pf-v5-c-button--m-danger--Color: var(--pf-v5-c-button--m-danger--hover--Color);
  --pf-v5-c-button--m-danger--BackgroundColor: var(--pf-v5-c-button--m-danger--hover--BackgroundColor);
}
.pf-v5-c-button.pf-m-danger:focus {
  --pf-v5-c-button--m-danger--Color: var(--pf-v5-c-button--m-danger--focus--Color);
  --pf-v5-c-button--m-danger--BackgroundColor: var(--pf-v5-c-button--m-danger--focus--BackgroundColor);
}
.pf-v5-c-button.pf-m-danger:active, .pf-v5-c-button.pf-m-danger.pf-m-active {
  --pf-v5-c-button--m-danger--Color: var(--pf-v5-c-button--m-danger--active--Color);
  --pf-v5-c-button--m-danger--BackgroundColor: var(--pf-v5-c-button--m-danger--active--BackgroundColor);
}
.pf-v5-c-button.pf-m-danger.pf-m-secondary {
  --pf-v5-c-button--m-danger--Color: var(--pf-v5-c-button--m-secondary--m-danger--Color);
  --pf-v5-c-button--m-danger--BackgroundColor: var(--pf-v5-c-button--m-secondary--m-danger--BackgroundColor);
  --pf-v5-c-button--after--BorderColor: var(--pf-v5-c-button--m-secondary--m-danger--after--BorderColor);
}
.pf-v5-c-button.pf-m-danger.pf-m-secondary:hover {
  --pf-v5-c-button--m-secondary--m-danger--Color: var(--pf-v5-c-button--m-secondary--m-danger--hover--Color);
  --pf-v5-c-button--m-secondary--m-danger--BackgroundColor: var(--pf-v5-c-button--m-secondary--m-danger--hover--BackgroundColor);
  --pf-v5-c-button--after--BorderColor: var(--pf-v5-c-button--m-secondary--m-danger--hover--after--BorderColor);
}
.pf-v5-c-button.pf-m-danger.pf-m-secondary:focus {
  --pf-v5-c-button--m-secondary--m-danger--Color: var(--pf-v5-c-button--m-secondary--m-danger--focus--Color);
  --pf-v5-c-button--m-secondary--m-danger--BackgroundColor: var(--pf-v5-c-button--m-secondary--m-danger--focus--BackgroundColor);
  --pf-v5-c-button--after--BorderColor: var(--pf-v5-c-button--m-secondary--m-danger--focus--after--BorderColor);
}
.pf-v5-c-button.pf-m-danger.pf-m-secondary:active, .pf-v5-c-button.pf-m-danger.pf-m-secondary.pf-m-active {
  --pf-v5-c-button--m-secondary--m-danger--Color: var(--pf-v5-c-button--m-secondary--m-danger--active--Color);
  --pf-v5-c-button--m-secondary--m-danger--BackgroundColor: var(--pf-v5-c-button--m-secondary--m-danger--active--BackgroundColor);
  --pf-v5-c-button--after--BorderColor: var(--pf-v5-c-button--m-secondary--m-danger--active--after--BorderColor);
}
.pf-v5-c-button.pf-m-danger.pf-m-link {
  --pf-v5-c-button--m-danger--Color: var(--pf-v5-c-button--m-link--m-danger--Color);
  --pf-v5-c-button--m-danger--BackgroundColor: var(--pf-v5-c-button--m-link--m-danger--BackgroundColor);
}
.pf-v5-c-button.pf-m-danger.pf-m-link:hover {
  --pf-v5-c-button--m-link--m-danger--Color: var(--pf-v5-c-button--m-link--m-danger--hover--Color);
  --pf-v5-c-button--m-link--m-danger--BackgroundColor: var(--pf-v5-c-button--m-link--m-danger--hover--BackgroundColor);
}
.pf-v5-c-button.pf-m-danger.pf-m-link:focus {
  --pf-v5-c-button--m-link--m-danger--Color: var(--pf-v5-c-button--m-link--m-danger--focus--Color);
  --pf-v5-c-button--m-link--m-danger--BackgroundColor: var(--pf-v5-c-button--m-link--m-danger--focus--BackgroundColor);
}
.pf-v5-c-button.pf-m-danger.pf-m-link:active, .pf-v5-c-button.pf-m-danger.pf-m-link.pf-m-active {
  --pf-v5-c-button--m-link--m-danger--Color: var(--pf-v5-c-button--m-link--m-danger--active--Color);
  --pf-v5-c-button--m-link--m-danger--BackgroundColor: var(--pf-v5-c-button--m-link--m-danger--active--BackgroundColor);
}
.pf-v5-c-button.pf-m-warning {
  color: var(--pf-v5-c-button--m-warning--Color);
  background-color: var(--pf-v5-c-button--m-warning--BackgroundColor);
}
.pf-v5-c-button.pf-m-warning:hover {
  --pf-v5-c-button--m-warning--Color: var(--pf-v5-c-button--m-warning--hover--Color);
  --pf-v5-c-button--m-warning--BackgroundColor: var(--pf-v5-c-button--m-warning--hover--BackgroundColor);
}
.pf-v5-c-button.pf-m-warning:focus {
  --pf-v5-c-button--m-warning--Color: var(--pf-v5-c-button--m-warning--focus--Color);
  --pf-v5-c-button--m-warning--BackgroundColor: var(--pf-v5-c-button--m-warning--focus--BackgroundColor);
}
.pf-v5-c-button.pf-m-warning:active, .pf-v5-c-button.pf-m-warning.pf-m-active {
  --pf-v5-c-button--m-warning--Color: var(--pf-v5-c-button--m-warning--active--Color);
  --pf-v5-c-button--m-warning--BackgroundColor: var(--pf-v5-c-button--m-warning--active--BackgroundColor);
}
.pf-v5-c-button.pf-m-control {
  --pf-v5-c-button--BorderRadius: var(--pf-v5-c-button--m-control--BorderRadius);
  --pf-v5-c-button--disabled--BackgroundColor: var(--pf-v5-c-button--m-control--disabled--BackgroundColor);
  --pf-v5-c-button--after--BorderWidth: var(--pf-v5-c-button--m-control--after--BorderWidth);
  --pf-v5-c-button--after--BorderColor: var(--pf-v5-c-button--m-control--after--BorderTopColor) var(--pf-v5-c-button--m-control--after--BorderRightColor) var(--pf-v5-c-button--m-control--after--BorderBottomColor) var(--pf-v5-c-button--m-control--after--BorderLeftColor);
  color: var(--pf-v5-c-button--m-control--Color);
  background-color: var(--pf-v5-c-button--m-control--BackgroundColor);
}
.pf-v5-c-button.pf-m-control::after {
  border-radius: initial;
}
.pf-v5-c-button.pf-m-control:hover {
  --pf-v5-c-button--m-control--Color: var(--pf-v5-c-button--m-control--hover--Color);
  --pf-v5-c-button--m-control--BackgroundColor: var(--pf-v5-c-button--m-control--hover--BackgroundColor);
  --pf-v5-c-button--m-control--after--BorderBottomColor: var(--pf-v5-c-button--m-control--hover--after--BorderBottomColor);
}
.pf-v5-c-button.pf-m-control:hover::after {
  border-bottom-width: var(--pf-v5-c-button--m-control--hover--after--BorderBottomWidth);
}
.pf-v5-c-button.pf-m-control:active, .pf-v5-c-button.pf-m-control.pf-m-active {
  --pf-v5-c-button--m-control--Color: var(--pf-v5-c-button--m-control--active--Color);
  --pf-v5-c-button--m-control--BackgroundColor: var(--pf-v5-c-button--m-control--active--BackgroundColor);
  --pf-v5-c-button--m-control--after--BorderBottomColor: var(--pf-v5-c-button--m-control--active--after--BorderBottomColor);
}
.pf-v5-c-button.pf-m-control:active::after, .pf-v5-c-button.pf-m-control.pf-m-active::after {
  border-bottom-width: var(--pf-v5-c-button--m-control--active--after--BorderBottomWidth);
}
.pf-v5-c-button.pf-m-control:focus {
  --pf-v5-c-button--m-control--Color: var(--pf-v5-c-button--m-control--focus--Color);
  --pf-v5-c-button--m-control--BackgroundColor: var(--pf-v5-c-button--m-control--focus--BackgroundColor);
  --pf-v5-c-button--m-control--after--BorderBottomColor: var(--pf-v5-c-button--m-control--focus--after--BorderBottomColor);
}
.pf-v5-c-button.pf-m-control:focus::after {
  border-bottom-width: var(--pf-v5-c-button--m-control--focus--after--BorderBottomWidth);
}
.pf-v5-c-button.pf-m-control.pf-m-expanded {
  --pf-v5-c-button--m-control--Color: var(--pf-v5-c-button--m-control--m-expanded--Color);
  --pf-v5-c-button--m-control--BackgroundColor: var(--pf-v5-c-button--m-control--m-expanded--BackgroundColor);
  --pf-v5-c-button--m-control--after--BorderBottomColor: var(--pf-v5-c-button--m-control--m-expanded--after--BorderBottomColor);
}
.pf-v5-c-button.pf-m-control.pf-m-expanded::after {
  border-bottom-width: var(--pf-v5-c-button--m-control--m-expanded--after--BorderBottomWidth);
}
.pf-v5-c-button.pf-m-plain {
  --pf-v5-c-button--disabled--Color: var(--pf-v5-c-button--m-plain--disabled--Color);
  --pf-v5-c-button--disabled--BackgroundColor: var(--pf-v5-c-button--m-plain--disabled--BackgroundColor);
  color: var(--pf-v5-c-button--m-plain--Color);
  background-color: var(--pf-v5-c-button--m-plain--BackgroundColor);
}
.pf-v5-c-button.pf-m-plain:hover {
  --pf-v5-c-button--m-plain--Color: var(--pf-v5-c-button--m-plain--hover--Color);
  --pf-v5-c-button--m-plain--BackgroundColor: var(--pf-v5-c-button--m-plain--hover--BackgroundColor);
}
.pf-v5-c-button.pf-m-plain:active, .pf-v5-c-button.pf-m-plain.pf-m-active {
  --pf-v5-c-button--m-plain--Color: var(--pf-v5-c-button--m-plain--active--Color);
  --pf-v5-c-button--m-plain--BackgroundColor: var(--pf-v5-c-button--m-plain--active--BackgroundColor);
}
.pf-v5-c-button.pf-m-plain:focus {
  --pf-v5-c-button--m-plain--Color: var(--pf-v5-c-button--m-plain--focus--Color);
  --pf-v5-c-button--m-plain--BackgroundColor: var(--pf-v5-c-button--m-plain--focus--BackgroundColor);
}
.pf-v5-c-button:disabled, .pf-v5-c-button.pf-m-disabled {
  pointer-events: none;
}
.pf-v5-c-button:disabled, .pf-v5-c-button.pf-m-disabled, .pf-v5-c-button.pf-m-aria-disabled {
  color: var(--pf-v5-c-button--disabled--Color);
  background-color: var(--pf-v5-c-button--disabled--BackgroundColor);
}
.pf-v5-c-button:disabled::after, .pf-v5-c-button.pf-m-disabled::after, .pf-v5-c-button.pf-m-aria-disabled::after {
  border-color: var(--pf-v5-c-button--disabled--after--BorderColor);
}
.pf-v5-c-button:disabled .pf-v5-c-badge, .pf-v5-c-button.pf-m-disabled .pf-v5-c-badge, .pf-v5-c-button.pf-m-aria-disabled .pf-v5-c-badge {
  --pf-v5-c-badge--m-unread--Color: var(--pf-v5-c-button--disabled__c-badge--Color);
  --pf-v5-c-badge--m-unread--BackgroundColor: var(--pf-v5-c-button--disabled__c-badge--BackgroundColor);
  --pf-v5-c-button--m-primary__c-badge--BorderWidth: 0;
}
.pf-v5-c-button.pf-m-aria-disabled {
  --pf-v5-c-button--after--BorderWidth: 0;
  --pf-v5-c-button--m-link--m-inline--hover--TextDecoration: none;
  cursor: default;
}
.pf-v5-c-button.pf-m-progress {
  --pf-v5-c-button--PaddingRight: var(--pf-v5-c-button--m-progress--PaddingRight);
  --pf-v5-c-button--PaddingLeft: var(--pf-v5-c-button--m-progress--PaddingLeft);
  transition: var(--pf-v5-c-button--m-progress--TransitionProperty) var(--pf-v5-c-button--m-progress--TransitionDuration);
}
.pf-v5-c-button.pf-m-in-progress {
  --pf-v5-c-button--m-link--m-inline--PaddingLeft: var(--pf-v5-c-button--m-link--m-inline--m-in-progress--PaddingLeft);
}
.pf-v5-c-button.pf-m-in-progress:not(.pf-m-plain) {
  --pf-v5-c-button--PaddingRight: var(--pf-v5-c-button--m-in-progress--PaddingRight);
  --pf-v5-c-button--PaddingLeft: var(--pf-v5-c-button--m-in-progress--PaddingLeft);
}
.pf-v5-c-button.pf-m-in-progress.pf-m-plain {
  --pf-v5-c-button--m-plain--Color: var(--pf-v5-c-button--m-in-progress--m-plain--Color);
  --pf-v5-c-button__progress--Left: var(--pf-v5-c-button--m-in-progress--m-plain__progress--Left);
  --pf-v5-c-button__progress--TranslateX: var(--pf-v5-c-button--m-in-progress--m-plain__progress--TranslateX);
}
.pf-v5-c-button.pf-m-in-progress.pf-m-plain > :not(.pf-v5-c-button__progress) {
  opacity: 0;
}

.pf-v5-c-button__icon.pf-m-start {
  margin-right: var(--pf-v5-c-button__icon--m-start--MarginRight);
}
.pf-v5-c-button__icon.pf-m-end {
  margin-left: var(--pf-v5-c-button__icon--m-end--MarginLeft);
}

.pf-v5-c-button__progress {
  position: absolute;
  top: var(--pf-v5-c-button__progress--Top);
  left: var(--pf-v5-c-button__progress--Left);
  line-height: 1;
  transform: translate(var(--pf-v5-c-button__progress--TranslateX), var(--pf-v5-c-button__progress--TranslateY));
}
.pf-v5-c-button__progress .pf-v5-c-spinner {
  --pf-v5-c-spinner--Color: currentcolor;
}

.pf-v5-c-button__count {
  display: inline-flex;
  align-items: center;
  margin-left: var(--pf-v5-c-button__count--MarginLeft);
}

:where(.pf-v5-theme-dark) .pf-v5-c-button {
  --pf-v5-c-button--disabled--Color: var(--pf-v5-global--disabled-color--300);
  --pf-v5-c-button--m-primary--BackgroundColor: var(--pf-v5-global--primary-color--300);
  --pf-v5-c-button--m-primary--Color: var(--pf-v5-global--primary-color--400);
  --pf-v5-c-button--m-tertiary--after--BorderColor: var(--pf-v5-global--BorderColor--100);
  --pf-v5-c-button--m-tertiary--Color: var(--pf-v5-global--palette--black-100);
  --pf-v5-c-button--m-tertiary--hover--after--BorderColor: var(--pf-v5-global--BorderColor--100);
  --pf-v5-c-button--m-tertiary--hover--Color: var(--pf-v5-global--palette--black-100);
  --pf-v5-c-button--m-tertiary--focus--after--BorderColor: var(--pf-v5-global--BorderColor--100);
  --pf-v5-c-button--m-tertiary--focus--Color: var(--pf-v5-global--palette--black-100);
  --pf-v5-c-button--m-tertiary--active--after--BorderColor: var(--pf-v5-global--BorderColor--100);
  --pf-v5-c-button--m-tertiary--active--Color: var(--pf-v5-global--palette--black-100);
  --pf-v5-c-button--m-warning--Color: var(--pf-v5-global--palette--black-900);
  --pf-v5-c-button--m-warning--hover--Color: var(--pf-v5-global--palette--black-900);
  --pf-v5-c-button--m-warning--focus--Color: var(--pf-v5-global--palette--black-900);
  --pf-v5-c-button--m-warning--active--Color: var(--pf-v5-global--palette--black-900);
  --pf-v5-c-button--m-warning--hover--BackgroundColor: var(--pf-v5-global--warning-color--200);
  --pf-v5-c-button--m-warning--focus--BackgroundColor: var(--pf-v5-global--warning-color--200);
  --pf-v5-c-button--m-warning--active--BackgroundColor: var(--pf-v5-global--warning-color--200);
  --pf-v5-c-button--m-danger--Color: var(--pf-v5-global--palette--black-900);
  --pf-v5-c-button--m-danger--hover--Color: var(--pf-v5-global--palette--black-900);
  --pf-v5-c-button--m-danger--focus--Color: var(--pf-v5-global--palette--black-900);
  --pf-v5-c-button--m-danger--active--Color: var(--pf-v5-global--palette--black-900);
  --pf-v5-c-button--m-link--disabled--Color: var(--pf-v5-global--disabled-color--100);
  --pf-v5-c-button--m-control--BackgroundColor: var(--pf-v5-global--BackgroundColor--400);
  --pf-v5-c-button--m-control--hover--BackgroundColor: var(--pf-v5-global--BackgroundColor--400);
  --pf-v5-c-button--m-control--active--BackgroundColor: var(--pf-v5-global--BackgroundColor--400);
  --pf-v5-c-button--m-control--focus--BackgroundColor: var(--pf-v5-global--BackgroundColor--400);
  --pf-v5-c-button--m-control--m-expanded--BackgroundColor: var(--pf-v5-global--BackgroundColor--400);
  --pf-v5-c-button--m-control--after--BorderTopColor: transparent;
  --pf-v5-c-button--m-control--after--BorderRightColor: transparent;
  --pf-v5-c-button--m-control--after--BorderBottomColor: var(--pf-v5-global--BorderColor--400);
  --pf-v5-c-button--m-control--after--BorderLeftColor: transparent;
  --pf-v5-c-button--m-control--hover--after--BorderBottomColor: var(--pf-v5-global--primary-color--100);
  --pf-v5-c-button--m-control--active--after--BorderBottomColor: var(--pf-v5-global--primary-color--100);
  --pf-v5-c-button--m-control--focus--after--BorderBottomColor: var(--pf-v5-global--primary-color--100);
  --pf-v5-c-button--m-control--m-expanded--after--BorderBottomColor: var(--pf-v5-global--primary-color--100);
  --pf-v5-c-button--m-control--disabled--BackgroundColor: var(--pf-v5-global--disabled-color--200);
  --pf-v5-c-button--m-primary__c-badge--BorderColor: var(--pf-v5-global--Color--100);
}
:where(.pf-v5-theme-dark) .pf-v5-c-button.pf-m-control:disabled::after {
  border: 0;
  border-bottom: var(--pf-v5-global--BorderWidth--sm) solid var(--pf-v5-global--palette--black-700);
}